export default "__VITE_ASSET__fpfgj1Xq__"